/**
 * Modal pour ajouter/modifier un paiement avec support OCR
 * Wrapper Dialog autour de PaiementFormContent
 */

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useModalProtection } from '@/hooks/useModalProtection';
import { PaiementFormContent } from './PaiementFormContent';
import type {
  PaiementClient,
  PaiementFormData,
  FactureClientSimple,
} from '@/types/paiement';


interface PaiementFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: PaiementFormData) => Promise<PaiementClient | null>;
  paiement?: PaiementClient | null; // Mode édition si fourni
  facturesClients: FactureClientSimple[];
  totalDevis?: number; // Total des devis pour le slider (maximum)
  resteAEncaisser?: number; // Reste à encaisser pour suggestion
}

export function PaiementFormModal({
  isOpen,
  onClose,
  onSubmit,
  paiement,
  facturesClients,
  totalDevis = 0,
  resteAEncaisser = 0,
}: PaiementFormModalProps) {
  const isEditing = !!paiement;
  useModalProtection(isOpen);

  const handleSubmit = async (data: PaiementFormData): Promise<PaiementClient | null> => {
    const result = await onSubmit(data);
    if (result) {
      onClose();
    }
    return result;
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent variant="industrial" className="max-w-lg">
        <DialogHeader>
          <DialogTitle>
            {isEditing ? 'Modifier le paiement' : 'Enregistrer un paiement'}
          </DialogTitle>
        </DialogHeader>

        <PaiementFormContent
          onSubmit={handleSubmit}
          onCancel={onClose}
          paiement={paiement}
          facturesClients={facturesClients}
          totalDevis={totalDevis}
          resteAEncaisser={resteAEncaisser}
        />
      </DialogContent>
    </Dialog>
  );
}

export default PaiementFormModal;
